<template>
  <div>
    <media v-for="(row, ids) in dataList" :key="ids" :option="row" />
    <!-- 分页 -->
    <page :total="tablePage.total" class="pagination" :page="tablePage.currentPage" @currentPage="currentPage"/>

  </div>
</template>

<script>
import media from "@/components/AuthorContent/mediaItem";
import page from "@/components/page/pages";
export default {
  components: { media, page },
  data() {
    return {
      pageNum: 1,
      dataList: [],
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  watch: {
    cityNo(e) {
      this.pageNum = 1;
      this.dataList = [];
      this.getLocalArticleLists();
    },
  },
  props: {
    cityNo: {
      type: [String, Number],
      deafult: 0,
    },
  },
  mounted() {
    this.getLocalArticleLists();
  },
  methods: {
    getLocalArticleLists() {
      if (this.status != "loadmore") {
        return;
      }
      this.status = "loading";
      /*localArticleLists({page: this.tablePage.currentPage, city: this.cityNo,}).then((res) => {
        this.status = "loadmore";
        res.content.forEach((item) => {
          if (!item.photo) {
            item.photo = [];
          }
          this.dataList.push(item);
        });
        if (res.content.length < 10) {
          this.status = "nomore";
        } else {
          this.pageNum++;
        }
      });*/
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>